import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem, FilterItemOperator, IStorageLocal, SortItem } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";
import { BaseColumnFormatter, BooleanFormatter, DateTimeFormatter, IDFormatter, NSColumn, NSTable, StringFormatter, StringFormatterSizeType, TableColumnInfo } from "namirasoft-site-react";
import { AssignmentRow } from "namirasoft-storage";
import { Component, createRef } from "react";
import { StorageRouterProps } from "../StorageRouterProps";

export interface AssignmentsTableProps extends NSARouterMakerResult, StorageRouterProps
{
    storage_user_id?: string;
    storage_id?: string;
}

interface AssignmentsTableState
{
    columns: TableColumnInfo[] | null;
}

export default class AssignmentsTable extends Component<AssignmentsTableProps, AssignmentsTableState>
{
    override state: AssignmentsTableState = { columns: null };

    private Table_Ref = createRef<NSTable<AssignmentRow>>();

    override componentDidMount(): void
    {
        this.setState({ columns: this.buildColumns() });
    }

    override componentDidUpdate(prev: AssignmentsTableProps): void
    {
        if (prev.storage_user_id !== this.props.storage_user_id || prev.storage_id !== this.props.storage_id)
            this.Table_Ref.current?.reload(null, null);
    }

    private buildColumns(): TableColumnInfo[]
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);
        let table = namirasoft.storage.tables.assignment;
        let columns: TableColumnInfo[] = [
            BaseColumnFormatter.getColumn(table.columns.id, new IDFormatter(namirasoft, null)),
        ];
        if (!this.props.storage_user_id)
            columns.push(BaseColumnFormatter.getColumn(table.columns.storage_user_id, new IDFormatter(namirasoft, new IStorageLocal())));
        if (!this.props.storage_id)
            columns.push(BaseColumnFormatter.getColumn(table.columns.storage_id, new IDFormatter(namirasoft, new IStorageLocal())));
        columns.push(BaseColumnFormatter.getColumn(table.columns.path_source, new StringFormatter(StringFormatterSizeType.FullName)));
        columns.push(BaseColumnFormatter.getColumn(table.columns.path_destination, new StringFormatter(StringFormatterSizeType.FullName)));
        columns.push(BaseColumnFormatter.getColumn(table.columns.can_list, new BooleanFormatter("Yes", "No")));
        columns.push(BaseColumnFormatter.getColumn(table.columns.can_download, new BooleanFormatter("Yes", "No")));
        columns.push(BaseColumnFormatter.getColumn(table.columns.can_create_file, new BooleanFormatter("Yes", "No")));
        columns.push(BaseColumnFormatter.getColumn(table.columns.can_create_directory, new BooleanFormatter("Yes", "No")));
        columns.push(BaseColumnFormatter.getColumn(table.columns.can_overwrite_file, new BooleanFormatter("Yes", "No")));
        columns.push(BaseColumnFormatter.getColumn(table.columns.can_delete_file, new BooleanFormatter("Yes", "No")));
        columns.push(BaseColumnFormatter.getColumn(table.columns.can_delete_directory, new BooleanFormatter("Yes", "No")));
        columns.push(BaseColumnFormatter.getColumn(table.columns.can_rename, new BooleanFormatter("Yes", "No")));
        columns.push(BaseColumnFormatter.getColumn(table.columns.can_copy, new BooleanFormatter("Yes", "No")));
        columns.push(BaseColumnFormatter.getColumn(table.columns.can_move, new BooleanFormatter("Yes", "No")));
        columns.push(BaseColumnFormatter.getColumn(table.columns.created_at, new DateTimeFormatter()));
        columns.push(BaseColumnFormatter.getColumn(table.columns.updated_at, new DateTimeFormatter()));
        return columns;
    }

    private getRows = async (page: number, size: number, sorts: SortItem[]): Promise<{ rows: AssignmentRow[], count: number }> =>
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);
        let table = namirasoft.storage.tables.assignment;
        let filters: FilterItem[] = [];
        if (this.props.storage_user_id)
            filters.push(new FilterItem(table, table.columns.storage_user_id, false, FilterItemOperator.all.equals, this.props.storage_user_id));
        if (this.props.storage_id)
            filters.push(new FilterItem(table, table.columns.storage_id, false, FilterItemOperator.all.equals, this.props.storage_id));
        return await this.props.servers.storage.assignment.List(filters, page, size, sorts, null);
    };

    override render()
    {
        let { columns } = this.state;
        return (
            <NSColumn style={{ width: "100%", marginTop: 16, gap: 8 }}>
                <div style={{ display: "flex", flexDirection: "column", gap: 8, width: "100%", flexGrow: 1 }}>
                    <NSTable<AssignmentRow>
                        ref={this.Table_Ref}
                        name="assignments"
                        checkbox={false}
                        columns={columns ?? this.buildColumns()}
                        getRows={this.getRows}
                        getRowKey={(row) => row.value.id}
                    />
                </div>
            </NSColumn>
        );
    }
}